import React from 'react';
import {
  Box,
  Container,
  SimpleGrid,
  Text,
  Link,
  VStack,
  HStack,
  Icon,
  useToast,
  Divider,
} from '@chakra-ui/react';

import { FaLinkedin, FaYoutube, FaDiscord, FaEnvelope, FaInstagram } from 'react-icons/fa';
import { useAppData } from '../store/dataStore';

const Footer = () => {
  const toast = useToast();
  const { appData } = useAppData();
  const { supportEmail } = appData;

  return (
    <Box bg="brand.800" color="white" py={12}>
      <Container maxW="container.xl">
        <SimpleGrid columns={{ base: 1, md: 4 }} spacing={8} mb={8}>
          <VStack align="start">
            <Text fontSize="2xl" fontWeight="900" bgGradient="linear(to-r, accent.gold, accent.green)" bgClip="text">
              idea2app
            </Text>
            <Text fontSize="sm" color="whiteAlpha.700">
              Empowering the next generation of AI developers
            </Text>
          </VStack>

          <VStack align="start">
            <Text fontWeight="600" mb={2}>Programs</Text>

            <Link href='/beginner-track' fontSize="sm" color="whiteAlpha.700" _hover={{ color: 'accent.gold' }}>Beginner Track</Link>

            <Link href="/experienced-track" fontSize="sm" color="whiteAlpha.700" _hover={{ color: 'accent.gold' }}>Experienced Track</Link>
            {/*<Link fontSize="sm" color="whiteAlpha.700" _hover={{ color: 'accent.gold' }}>Corporate Training</Link>*/}
          </VStack>

          <VStack align="start">
            <Text fontWeight="600" mb={2}>Resources</Text>
            <Link
              fontSize="sm"
              color="whiteAlpha.700"
              _hover={{ color: 'accent.gold' }}
              href="https://blog.ojasamirai.com/"
            >
              Blog
            </Link>
            <Link
              fontSize="sm"
              color="whiteAlpha.700"
              _hover={{ color: 'accent.gold' }}
              onClick={() => toast({ title: "Coming soon", status: "info" })}
            >
              Success Stories
            </Link>
            <Link
              fontSize="sm"
              color="whiteAlpha.700"
              _hover={{ color: 'accent.gold' }}
              onClick={() => toast({ title: "Coming soon", status: "info" })}
            >
              Free Resources
            </Link>
          </VStack>
          <VStack align="start">
            <Text fontWeight="600" mb={2}>Connect</Text>
            <HStack spacing={4}>
              <Link href="https://www.linkedin.com/in/ojasa-mirai-llp-aa3968388/" isExternal>
                <Icon as={FaLinkedin} boxSize={6} cursor="pointer" _hover={{ color: 'accent.gold' }} />
              </Link>
              <Link href="https://www.youtube.com/@OjasaMirai" isExternal>
                <Icon as={FaYoutube} boxSize={6} cursor="pointer" _hover={{ color: 'accent.gold' }} />
              </Link>
              <Link href="https://discord.com/channels/1404494048936591390/1422191821152587796" isExternal>
                <Icon as={FaDiscord} boxSize={6} cursor="pointer" _hover={{ color: 'accent.gold' }} />
              </Link>
              {/*Instagram*/}
              <Link href="https://www.instagram.com/ojasa_mirai_llp/" isExternal>
                <Icon as={FaInstagram} boxSize={6} cursor="pointer" _hover={{ color: 'accent.gold' }} />
              </Link>
              <Link href={`mailto:${supportEmail}`} isExternal>
                <Icon as={FaEnvelope} boxSize={6} cursor="pointer" _hover={{ color: 'accent.gold' }} />
              </Link>
            </HStack>
          </VStack>
        </SimpleGrid>


        <Box mb={6}>
          <Text fontSize="sm" color="whiteAlpha.700" mb={2}>Trusted by learners at startups and product companies</Text>
          <HStack spacing={3}>
            <Box px={3} py={1} bg="whiteAlpha.200" borderRadius="md">14-day Money-back</Box>
            <Box px={3} py={1} bg="whiteAlpha.200" borderRadius="md">Secure Payments</Box>
            <Box px={3} py={1} bg="whiteAlpha.200" borderRadius="md">Lifetime Community Access</Box>
          </HStack>
        </Box>
        <Divider borderColor="whiteAlpha.300" my={8} />

        <HStack justify="space-between" flexWrap="wrap">
          <Text fontSize="sm" color="whiteAlpha.600">
            © 2025 Ojasa Mirai. All rights reserved.
          </Text>
          <HStack spacing={6}>
            <Link fontSize="sm" color="whiteAlpha.600" _hover={{ color: 'accent.gold' }} href="/privacy">
              Privacy Policy</Link>
            <Link fontSize="sm" color="whiteAlpha.600" _hover={{ color: 'accent.gold' }} onClick={() => toast({ title: "Coming soon", status: "info" })}>
              Terms of Service</Link>
            <Link fontSize="sm" color="whiteAlpha.600" _hover={{ color: 'accent.gold' }} href="https://affiliates.ojasamirai.com">
              Partner</Link>
          </HStack>
        </HStack>
      </Container>
    </Box>
  );
};

export default Footer;
